/**
 * CosmicBackground — Simplified.
 * Renders a solid dark background with a subtle gradient.
 * Replaces the previous starfield canvas, animated blobs, and grain overlay.
 */
export default function CosmicBackground() {
  return (
    <>
      {/* Solid base */}
      <div
        className="fixed inset-0 w-full h-full -z-40"
        style={{ background: "#06010E" }}
      />

      {/* Very subtle ambient gradient — barely perceptible */}
      <div
        className="fixed inset-0 -z-30 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 20% 0%, rgba(112,0,255,0.06) 0%, transparent 50%), radial-gradient(ellipse at 80% 100%, rgba(0,194,255,0.04) 0%, transparent 50%)",
        }}
      />
    </>
  );
}
